// extracted by mini-css-extract-plugin
module.exports = {"Rating":"Rating_Rating__fRCkL","Star":"Rating_Star__1NHZ_","Selected":"Rating_Selected__1lf5I","Unselected":"Rating_Unselected__3ghQM","Disabled":"Rating_Disabled__h5_FM"};